import { usePreferences } from 'context/preferences/PreferencesContext'
import { ContactCompanyType } from 'models/contact_companies'
import { useParams } from 'react-router-dom'
import { getIdWithPrefix } from 'utils/pathUtils'
import { NewHospitalPage } from '../new-company-pages/NewHospitalPage'

export default function HospitalPage() {
  const urlParams = useParams()
  const { preferences } = usePreferences()
  const hospitalID = urlParams?.hospital_id
    ? getIdWithPrefix(
        urlParams?.hospital_id,
        preferences?.company_type_prefix_map[ContactCompanyType.Hospital]
      )
    : undefined

  return <NewHospitalPage hospitalID={hospitalID} />
}
